var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.process,{tag:"component",on:{"changeSaveButton":function($event){return _vm.$emit('changeSaveButton', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }